<template>
  <v-container id="alerts" fluid tag="section">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      color="#007bff"
      :height="45"
      :width="75"
      :is-full-page="fullPage"
    ></loading>

    <v-row justify="center">
      <v-dialog v-model="toggleFileUploadModel" max-width="600" persistent>
        <template>
          <v-card>
            <v-form
              ref="addReportForm"
              v-model="validateAddReport"
              lazy-validation
            >
              <v-card-title>
                <b style="font-size: 22px !important">
                  Import Panelist Score
                </b>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row
                    justify="center"
                    style="text-align: center; font-size: 14px"
                  >
                    <b style="line-height: 31px">
                      Upload CSV with one entry per row and fields in order:
                    </b>

                    PanelistID, FICO Score, VantageScore, CreditVision, Score
                    Month, Score Year
                  </v-row>

                  <v-row justify="center">
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        label="File input*"
                        accept=".csv"
                        outlined
                        dense
                        v-model="reportFile"
                      ></v-file-input>
                    </v-col>
                  </v-row>

                  <v-row style="padding-left: 6%; margin-top: -42px">
                    <v-col>
                      <small>*indicates required field</small>
                      <br />

                      <a
                        @mouseover="isHovering = true"
                        @mouseleave="isHovering = false"
                        :class="isHovering ? 'underline' : 'link-color'"
                        :href="sampleFile"
                      >
                        Sample file
                      </a>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  :disabled="!validateAddReport"
                  color="primary"
                  class="mr-4"
                  @click="addReport"
                >
                  Upload
                </v-btn>

                <v-btn
                  color="default"
                  @click="toggleFileUploadModel = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </template>
      </v-dialog>
    </v-row>


    <!-- Existing Table -->
    <v-row v-if="!showImportTable">
      <v-col cols="1">
        <div class="text-left">
          <v-btn
            small
            color="primary"
            dark
            class="mt-5"
            @click="openImportTable"
            v-show="checkIfOperationExistForModule('import')"
          >
            Add
          </v-btn>
        </div>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :headers="headers"
          item-key="import_file_id"
          :page.sync="page"
          :items="panalist_score"
          :options.sync="options"
          :server-items-length="totalReports"
          :loading="loading"
          class="elevation-1"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <!-- Date -->
          <template v-slot:item.import_file_date="{ item }">
            {{ item.import_file_date || "" }}
          </template>

          <!-- File -->
          <template v-slot:item.file="{ item }">
            {{ item.file || "" }}
          </template>

          <!-- Log User -->
          <template v-slot:item.userName="{ item }">
            {{ item.userName || "" }}
          </template>

          <!-- Active -->
          <template v-slot:item.active="{ item }">
            {{ item.active || "" }}
          </template>

          <!-- Action -->
          <!-- Action -->
<template v-slot:item.Action="{ item }">
  <v-btn
    v-if="String(item.active).trim().toLowerCase() === 'yes'"
    small
    color="danger"
    text
    @click="removeData(item)"
  >
    Remove data
  </v-btn>
  <span v-else></span>
</template>
        </v-data-table>

        <div class="text-center pt-4 pb-4">
          <Pagination
            :isloading="isLoading"
            :startRecord="startRecord"
            :currentPage="currentPage"
            :lastPage="lastPage"
            :lastRecord="lastRecord"
            :totRecords="totRecords"
            :isCurrentPageClass="isCurrentPageClass"
            :getLastPageClass="getLastPageClass"
            :totPage="totPage"
            :getPages="getPages"
            @handlePerPage="handlePerPage"
            @paginate="paginate"
            @last="last"
            @getDataByPage="getDataByPage"
            :showPerPage="showPerPage"
          />
        </div>
      </v-col>
    </v-row>

    <!-- Import Table -->
    <v-row v-else>
      <v-col cols="12">
        <!-- File Upload Section -->
        <div style="width: 35%" class="mb-4">
          <v-file-input
            label="File input*"
            accept=".csv"
            outlined
            dense
            v-model="reportFile"
          ></v-file-input>
        </div>

        <!-- Buttons -->
        <div class="mb-4">
          <v-btn
            small
            color="primary"
            dark
            class="mr-2"
            :disabled="!reportFile"
            @click="addReport"
          >
            Import
          </v-btn>

          <v-btn
            small
            color="default"
            @click="showImportTable = false"
          >
            Cancel
          </v-btn>
        </div>

        <!-- Possible Field Headings -->
    <div>
  <b>Possible Field Headings:</b>

  <v-simple-table class="mt-2">
    <thead>
      <tr>
        <th style="width: 30%">Field</th>
        <th>Possible Values / Type</th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(value, key) in possibleHeadings"
        :key="key"
      >
        <td>{{ key }}</td>

        <td>
          <template v-if="Array.isArray(value)">
            {{ value.join(", ") }}
          </template>

          <template v-else>
            {{ value }}
          </template>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Pagination from "./component/Pagination.vue";
import moment from "moment";
import Index from "./Index.vue";
export default {
  name: "PanelistScore",

  components: {
    Loading,
    Pagination,
  },

  data: () => ({
    // Loading
    loading: false,
    isLoading: true,
    fullPage: true,

    query: "",
    showImportTable: false,
    toggleFileUploadModel: false,
    isHovering: false,
possibleHeadings: {},
    // Form
    validateAddReport: false,
    reportDate: null,
    reportName: "",
    reportDesc: "",
    reportFile: null,
    editFid: "",
    editFileName: "",

    // Pagination
    perpage: 50,
    totRecords: 0,
    page: 1,
    showPerPage: false,

    // Table data
    selected: [],
    options: {},
    panalist_score: [],
    pageCount: 0,
    totalReports: 0,

    editReportMode: false,
    fromDateMenu: false,
    fromDateVal: null,

    sampleFile:
      "https://files.competiscan.com/fileuploads/17238scoreUploads_sample.csv",

    max: moment(new Date()).format("YYYY-MM-DD"),
    date: new Date().toISOString().substr(0, 7),
    date1: "",

    // Kept for existing logic
    sortby: "competi_id",
    sortDesc: false,
    sort: "asc",
    reset_flag: false,

    /*
     * Main table headers
     *
     * Date sorting is disabled as requested.
     */
    headers: [
      {
        text: "Date",
        value: "import_file_date",
        sortable: false,
      },
      {
        text: "File",
        value: "file",
      },
      {
        text: "Log User",
        value: "userName",
      },
      {
        text: "Active",
        value: "active",
      },
      {
        text: "Action",
        value: "Action",
      },
    ],

    errorHeaders: [
      {
        text: "Row num",
        value: "row_num",
      },
      {
        text: "Panelist ID",
        value: "PanelistID",
      },
      {
        text: "FICO Score",
        value: "FICO Score",
      },
      {
        text: "Vantage Score",
        value: "VantageScore",
      },
      {
        text: "Credit Vision",
        value: "CreditVision",
      },
      {
        text: "Score Date",
        value: "Score Month",
      },
    ],

    availableHolidayDates: [],
    panelist_ids: "",
    holidayControl: 0,
    menu: false,
    errorList: [],
    errorModel: false,
  }),

  computed: {
    fromDate: function () {
      let date = this.date1;
      let dateArr = date.split("-");
      let month = dateArr[1];
      let year = dateArr[0];

      return year + "-" + month + "-01";
    },

    toDate: function () {
      let date = moment(this.fromDate)
        .add(1, "M")
        .format("YYYY-MM-DD");

      let dateArr = date.split("-");
      let month = dateArr[1];
      let year = dateArr[0];

      return year + "-" + month + "-01";
    },

    panelist_ids_arr: function () {
      if (this.panelist_ids == "") {
        return [];
      } else {
        let arr = this.panelist_ids.split(",");
        let new_arr = [];

        arr.forEach((id) => {
          new_arr.push(id.trim());
        });

        return new_arr;
      }
    },

    fromDateDisp() {
      return this.fromDateVal;
    },

    // Pagination
    startRecord: function () {
      if (!this.totRecords) {
        return 0;
      }

      return (
        parseInt(this.lastRecord) -
        parseInt(this.perpage) +
        parseInt(1)
      );
    },

    lastRecord: function () {
      if (!this.totRecords) {
        return 0;
      }

      return Math.min(
        this.perpage * this.currentPage,
        this.totRecords
      );
    },

    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },

    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },

    totPage: function () {
      if (!this.totRecords) {
        return 0;
      }

      return Math.ceil(
        parseInt(this.totRecords) / parseInt(this.perpage)
      );
    },

    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },

    currentPage: function () {
      return this.page;
    },

    lastPage: function () {
      if (!this.totRecords) {
        return 1;
      }

      return Math.ceil(
        parseInt(this.totRecords) / parseInt(this.perpage)
      );
    },

    endIndex: function () {
      if (this.page == 1) {
        return this.perpage;
      } else {
        return this.perpage * this.page;
      }
    },

    startIndex: function () {
      if (this.page == 1) {
        return this.perpage * 0;
      } else {
        return this.endIndex - this.perpage;
      }
    },
  },

  watch: {
    page(obj) {
      this.page = obj;
    },

    /*
     * Removed old sorting watcher.
     *
     * The new getImportData API does not require
     * sorted_by / sorted_column_name.
     */
    toggleFileUploadModel(o) {
      let view = this;

      if (!o) {
        view.reportFile = null;
      }
    },
  },

  mounted() {
    const d = new Date();

    const tempmonth = d.getMonth() + 1;

    let month = 0;

    if (tempmonth < 10) {
      month = `0${tempmonth}`;
    } else {
      month = tempmonth;
    }

    const year = d.getFullYear();

    console.log(year + "-" + month);

    this.date1 = year + "-" + month;

    /*
     * Load Import Data when page opens.
     */
    this.getImportData();
  },

  methods: {
    // Pagination methods
    getDataByPage(value) {
      this.page = value;
      this.getImportData();
    },
    removeData(item) {
  const view = this;

  if (!item || !item.import_file_id) {
    view.$swal.fire({
      icon: "error",
      title: "Error",
      text: "Import file ID is missing.",
    });
    return;
  }

  view.$swal
    .fire({
      title: "Remove data?",
      text: "Are you sure you want to remove this imported data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it",
      cancelButtonText: "Cancel",
    })
    .then((result) => {
      if (!result.value) {
        return;
      }

      const inactiveUrl = view.$url("INACTIVE");

      const payload = {
        import_file_id: item.import_file_id,
      };

      view.isLoading = true;

      view.$fetch({
        requiresAuth: false,
        operation: "view",
        vueScope: view,
      })
        .put(inactiveUrl, payload, {
          headers: {
            Authorization: view.$utils.getCookies("access_token"),
            Userid: view.$utils.getCookies("user_id"),
          },
        })
        .then((response) => {
          view.isLoading = false;

          view.$swal.fire({
            icon: "success",
            title: "Success",
            text:
              response.data?.message ||
              "Data removed successfully.",
          }).then(() => {
            view.getImportData();
          });
        })
        .catch((error) => {
          view.isLoading = false;

          console.error("INACTIVE API error:", error);

          view.$swal.fire({
            icon: "error",
            title: "Error",
            text:
              error.response?.data?.message ||
              "Unable to remove data. Please try again.",
          });
        });
    });
},
    openImportTable() {
  this.showImportTable = true;
  this.getPossibleHeadings();
},
getPossibleHeadings() {
  const view = this;

  // const possibleHeadingsUrl =
  //   "https://api1-uat.competiscan.com/energy-dashboard-client/v1/get-possible-headings";

const possibleHeadingsUrl =this.$url("POSSIBLEHEADING") ;


    
  view.isLoading = true;

  this.$fetch({
    requiresAuth: false,
    operation: "view",
    vueScope: view,
  })
    .get(possibleHeadingsUrl)
    .then((response) => {
      view.isLoading = false;

      if (response.data) {
        view.possibleHeadings = response.data;
      } else {
        view.possibleHeadings = {};
      }
    })
    .catch((error) => {
      view.isLoading = false;

      view.possibleHeadings = {};

      console.error(
        "getPossibleHeadings API error:",
        error
      );
    });
},
    handlePerPage(value) {
      this.perpage = value;
      this.page = 1;
      this.getImportData();
    },

    paginate(n) {
      this.page =
        n === 0
          ? 1
          : parseInt(this.currentPage) + parseInt(n);

      this.getImportData();
    },

    last() {
      this.page = this.lastPage;
      this.getImportData();
    },

    openReportModel(editMode, fid = 0) {
      this.toggleFileUploadModel = true;

      if (editMode) {
        this.editReportMode = true;
      } else {
        this.editReportMode = false;
        this.reportName = "";
        this.reportDesc = "";
        this.reportDate = null;
      }

      if (fid != 0) {
        this.getClientReport(fid);
      }
    },

 addReport() {
  const view = this;
  view.errorList = [];

  // Validate the form only when it exists (Upload dialog).
  if (
    view.$refs.addReportForm &&
    !view.$refs.addReportForm.validate()
  ) {
    return;
  }

  // Validate the selected file.
  if (!view.reportFile) {
    view.$swal.fire({
      icon: "error",
      title: "Error",
      text: "Please select csv file!",
    });
    return;
  }

  const fileName = view.reportFile.name || "";
  if (!fileName.toLowerCase().endsWith(".csv")) {
    view.$swal.fire({
      icon: "error",
      title: "Error",
      text: "Only csv format allowed!",
    });
    return;
  }

  const formData = new FormData();
  formData.append("file", view.reportFile);

  // IMPORTFILE API
  const manage_reports_url = view.$url("IMPORTFILE");

  console.log("IMPORTFILE URL:", manage_reports_url);
  view.isLoading = true;

  view.$fetch({
    requiresAuth: true,
    operation: "add",
    vueScope: view,
  })
    .post(manage_reports_url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      view.isLoading = false;
      view.toggleFileUploadModel = false;

      console.log("IMPORTFILE Response:", response);

      view.errorList =
        response.data && response.data.data
          ? response.data.data
          : [];

      if (
        response.data &&
        response.data.message === "File uploaded successfully."
      ) {
        view.$swal
          .fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
          })
          .then(() => {
            view.reportFile = null;
            view.showImportTable = false;
            view.getImportData();
          });
      } else {
        view.$swal
          .fire({
            icon: "success",
            title: "Success",
            text: response.data.message || "File processed.",
            showCancelButton: true,
            confirmButtonText: "Show Error table",
            cancelButtonText: "Ok",
            showCloseButton: true,
            allowOutsideClick: false,
          })
          .then((result) => {
            if (result.value) {
              view.errorModel = true;
            } else {
              view.getImportData();
            }
          });
      }
    })
    .catch((error) => {
      view.isLoading = false;

      console.error("IMPORTFILE API error:", error);

      view.$swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response.data.message
            : "Something went wrong.",
      });
    });
},

    getEventsList() {
      var eventsDates = document.querySelectorAll(
        ".v-date-picker-table .v-btn"
      );

      for (var i = 0; i < eventsDates.length; i++) {
        let nextSibling = eventsDates[i].children;

        if (nextSibling[1] != undefined) {
          nextSibling[0].style.color = "#ff0000";
        }
      }

      this.holidayControl = 1;
    },

    reset() {
      let view = this;

      view.reset_flag = true;
      view.page = 1;
      view.date1 = new Date()
        .toISOString()
        .substr(0, 7);
      view.panelist_ids = "";

      view.sortby = "competi_id";
      view.sortDesc = false;
      view.sort = "asc";

      view.getImportData();
    },

    /*
     * Get Import Data
     *
     * API:
     * https://api1-uat.competiscan.com/energy-dashboard-client/v1/getImportData
     *
     * Body:
     * {
     *   page_number: 1,
     *   page_size: 155
     * }
     *
     * Headers:
     * Authorization -> access_token cookie
     * Userid        -> user_id cookie
     */
    getImportData(page = this.page) {
      const view = this;

      view.isLoading = true;
      view.loading = true;

      const importDataUrl = this.$url("IMPORTDATA")  ;
      /*
       * API request body.
       *
       * User specifically requested page_size = 155.
       */
      const data = {
        page_number: page || 1,
        page_size: 155,
      };

      this.$fetch({
        requiresAuth: false,
        operation: "view",
        vueScope: view,
      })
        .post(importDataUrl, data, {
          headers: {
            Authorization:
              this.$utils.getCookies("access_token"),

            Userid:
              this.$utils.getCookies("user_id"),
          },
        })
        .then((response) => {
          view.isLoading = false;
          view.loading = false;

          console.log(
            "getImportData Response:",
            response
          );

          if (
            response.data &&
            Array.isArray(response.data.data)
          ) {
            view.panalist_score = response.data.data;

            /*
             * API response currently contains data array
             * but no separate total count.
             */
            view.totalReports =
              response.data.data.length;

            view.totRecords =
              response.data.data.length;
          } else {
            view.panalist_score = [];
            view.totalReports = 0;
            view.totRecords = 0;
          }

          view.reset_flag = false;
        })
        .catch((error) => {
          view.isLoading = false;
          view.loading = false;

          view.panalist_score = [];
          view.totalReports = 0;
          view.totRecords = 0;

          console.error(
            "getImportData API error:",
            error
          );
        });
    },

    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(
        this,
        type
      );
    },

    closeErrorMethods() {
      let view = this;

      view.errorModel = false;

      /*
       * Refresh import data after closing error popup.
       */
      view.getImportData();
    },
  },
};
</script>

<style>
.link-color {
  font-size: 13px;
  text-decoration: none;
}

.underline {
  color: black !important;
  cursor: pointer;
  font-size: 13px;
  text-decoration: underline;
}
</style>